import { render, staticRenderFns } from "./TabelaDeAdiantamentos.vue?vue&type=template&id=9ff645cc&scoped=true"
import script from "./TabelaDeAdiantamentos.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaDeAdiantamentos.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaDeAdiantamentos.vue?vue&type=style&index=0&id=9ff645cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff645cc",
  null
  
)

export default component.exports